import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  show() {
    const url = apiRoutes.apiV1FirebaseTokenPath();

    return FetchHelpers.get(url);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/FirebaseTokenRepository.js